<template>
  <app-page-subsection v-if="list.length > 0" :title="title">
    <course-card-carousel id="course_page_suggestions" :list="list" />
  </app-page-subsection>
</template>

<script lang="ts" setup>
import type { CoursePageView } from "~/business-areas/course/course.model";

const properties = defineProps<{
  course: CoursePageView;
}>();

const mainTag = computed(() => properties.course.tags[0]);

const { data: list } = useCourseList(
  `course_page_${properties.course.slug}`,
  {
    excludeSlugs: [properties.course.slug],
    tags: mainTag.value ? [mainTag.value.path] : undefined,
  },
  { server: false, lazy: true },
);

const { t } = useI18n();

const title = computed(() => {
  if (!mainTag.value) return t("course.card_list.default_title");

  return t("course.card_list.per_tag_title", { tag: mainTag.value.label });
});
</script>
